import { render, staticRenderFns } from "./GalleryPublicFile.vue?vue&type=template&id=60bedd8d&scoped=true"
import script from "./GalleryPublicFile.vue?vue&type=script&lang=js"
export * from "./GalleryPublicFile.vue?vue&type=script&lang=js"
import style0 from "./GalleryPublicFile.vue?vue&type=style&index=0&id=60bedd8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bedd8d",
  null
  
)

export default component.exports